// extracted by mini-css-extract-plugin
module.exports = {"sortIconOnly":"_3YSSEHxGflpTdVgSUYAV1q"};